module.exports = __webpack_public_path__ + "img/reload.640b4817.svg";